import React from 'react';
import './Input.css';

const Input = ({ 
  type = 'text',
  label,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  id,
  name,
  className = '',
  ...props
}) => {
  const inputId = id || name || Math.random().toString(36).substr(2, 9);
  
  const classes = [
    'ui-input__field',
    error ? 'ui-input__field--error' : '',
    disabled ? 'ui-input__field--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="ui-input">
      {label && (
        <label htmlFor={inputId} className="ui-input__label">
          {label}
          {required && <span className="ui-input__required">*</span>}
        </label>
      )}
      <div className="ui-input__wrapper">
        <input
          id={inputId}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          name={name}
          className={classes}
          {...props}
        />
      </div>
      {error && <span className="ui-input__error">{error}</span>}
    </div>
  );
};

export default Input; 